
<template>
    <div class="col-lg-12">
        <div class="card shadow">
            <div class="table-responsive">
                <base-table
                    class="table align-items-center table-flush"
                    thead-classes="thead-light"
                    tbody-classes="list"
                    :data="records.data"
                >
                    <template slot="columns">
                        <th width="2%">S/N</th>
                        <th width="20%">Doctor's Name</th>
                        <th width="15%">Folio Number</th>
                        <th width="15%">Email Address</th>
                        <th width="10%">Gender</th>
                        <th width="5%">&nbsp;</th>
                    </template>

                    <template
                        slot-scope="{row, index}"
                    >
                        <td class="budget">
                            {{ index+1}}
                        </td>
                        <td class="text-capitalize">
                            {{ row.first_name ? getName(row) : 'N/A' }}
                            
                        </td>
                        <td>
                            <badge size="sm" type="primary">
                                {{ row.folio_number ? row.folio_number : 'N/A' }}
                            </badge>
                        </td>
                        <td>
                            {{ row.email ? row.email : 'N/A' }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.gender ? row.gender : 'N/A' }}
                        </td>
                        <td>
                            <base-button
                                type="info" size="sm"
                                @click="$emit('findDoctor', row.email)"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            >
                                <i class="fa fa-user"></i> Get Profile
                            </base-button>
                        </td>
                    </template>
                </base-table>
            </div>
        </div>
    </div>
</template>
<script>

  export default {
    name: 'DisplayDoctors',
    props: ['records', 'privileges'],
    methods: {
        getName(record) {
            let name = record.first_name;
            name += record.other_name ? ' '+record.other_name+' ' : ' ';
            name += record.last_name;
            return name;
        }
    }
  };
</script>
<style></style>
